/**
 * @see https://nuxt.com/docs/getting-started/state-management#shared-state
 * @returns Ref<boolean>
 */
export const useAuthState = () => useState<boolean>('isAuthenticated');
